<mat-dialog-content class="bg-primary">
    <table>
        <tr>
            <td><mat-icon class="message-box-icon fg-primary-contrast">{{data.icon}}</mat-icon></td>
            <td class="fg-primary-contrast">{{data.text}}</td>
        </tr>
    </table>
</mat-dialog-content>

<mat-dialog-actions align="end" class="bg-primary">
    <button mat-flat-button color="primary" [mat-dialog-close]="true">OK</button>
</mat-dialog-actions>

